/* Quick-add sizes on product cards.
   Visual design is left entirely to theme.css (row slides up over the image on hover).
   This script only handles the click: add to cart via /cart/add.js so Essential
   Slide Cart opens; if the add fails, send the shopper to the product page. */
if (!window.__hoverSizesLoaded) {
  window.__hoverSizesLoaded = true;

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.hover-size__btn');
    if (!btn || btn.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = btn.dataset.variantId;
    const panel = btn.closest('.product-card__hover-sizes');
    const productUrl = panel ? panel.dataset.productUrl : null;

    if (!variantId) {
      if (productUrl) window.location.href = productUrl;
      return;
    }

    if (panel && panel.dataset.adding) return;
    if (panel) panel.dataset.adding = '1';

    try {
      const formData = new FormData();
      formData.set('id', variantId);
      formData.set('quantity', '1');

      const addResponse = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: formData
      });

      if (!addResponse.ok) throw new Error('add failed');

      // Keep the theme's cart count / dot in sync
      try {
        const cartData = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cartData }
          })
        );
      } catch (_) { /* count refresh is non-critical */ }

      // Brief confirmation using the theme's own "added" style
      btn.classList.add('hover-size__btn--added');
      setTimeout(() => {
        btn.classList.remove('hover-size__btn--added');
        if (panel) delete panel.dataset.adding;
      }, 1500);

    } catch (e) {
      if (panel) delete panel.dataset.adding;
      if (productUrl) window.location.href = productUrl;
    }
  });
}
